import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import EditableAutocomplete from "../../../components/EditableAutocomplete.js";
import EditableField from "../../../components/EditableField.js";
import EditButton from "../../../components/EditButton.js";

export default function CharacterInvolvements({
  buttonAriaLabel,
  handleChange,
  handleDelete,
  involvements,
  isEditing,
  plotLabel,
  plotNameLabel,
  predictiveList = [],
}) {
  return (
    <List>
      {involvements.map((item, index) => {
        const { plot: { id, name } = {}, involvement } = item;
        const collapsedName = name?.replaceAll(" ", "");
        const plotNameId = `character-plot-${collapsedName}`;

        return (
          <Box key={index} display="flex" alignItems="start">
            <ListItem alignItems="flex-start" disableGutters>
              <ListItemText
                disableTypography
                primary={
                  <EditableAutocomplete
                    disabledOptions={(option) =>
                      involvements.some(({ plot }) => plot?.id === option.id)
                    }
                    id={plotNameId}
                    isEditing={!item.id}
                    label={plotNameLabel}
                    onChange={(event, value) =>
                      handleChange({
                        field: "plot",
                        index,
                        value: value || {},
                      })
                    }
                    optionLabel={(option) => option.name || ""}
                    options={predictiveList}
                    route={`/plots/plots/${id}`}
                    state={{ id }}
                    text={name}
                    value={
                      predictiveList?.find((option) => option.id === id) || {}
                    }
                  />
                }
                secondary={
                  <EditableField
                    id={`plot-character-involvement-${collapsedName}`}
                    isEditing={isEditing}
                    label={plotLabel}
                    multiline
                    onChange={({ target }) =>
                      handleChange({
                        field: "involvement",
                        index,
                        value: target.value,
                      })
                    }
                    text={involvement}
                    value={involvement ?? ""}
                    variant="body2"
                  />
                }
                sx={{ display: "flex", flexDirection: "column" }}
              />
            </ListItem>
            {isEditing && (
              <EditButton
                ariaLabel={buttonAriaLabel}
                isEditing={isEditing}
                onClick={() => handleDelete(index)}
                primaryIcon={<DeleteOutlineIcon />}
              />
            )}
          </Box>
        );
      })}
    </List>
  );
}
